// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"672dcc87","911":"427ec793"}[chunkId] + ".chunk.css";
};